<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
  >
    <path
      d="M35 23.8926V21.3926C34.9916 18.2926 34.0267 15.2709 32.2369 12.7398C30.4472 10.2087 27.9198 8.29163 25 7.25039V6.39258C25 5.72954 24.7366 5.09365 24.2678 4.62481C23.7989 4.15597 23.163 3.89258 22.5 3.89258H17.5C16.837 3.89258 16.2011 4.15597 15.7322 4.62481C15.2634 5.09365 15 5.72954 15 6.39258V7.25039C12.0802 8.29163 9.55284 10.2087 7.76309 12.7398C5.97334 15.2709 5.0084 18.2926 5 21.3926V23.8926C4.33696 23.8926 3.70107 24.156 3.23223 24.6248C2.76339 25.0937 2.5 25.7295 2.5 26.3926V30.1426C2.5 30.8056 2.76339 31.4415 3.23223 31.9103C3.70107 32.3792 4.33696 32.6426 5 32.6426H35C35.663 32.6426 36.2989 32.3792 36.7678 31.9103C37.2366 31.4415 37.5 30.8056 37.5 30.1426V26.3926C37.5 25.7295 37.2366 25.0937 36.7678 24.6248C36.2989 24.156 35.663 23.8926 35 23.8926ZM32.5 21.3926V23.8926H25V9.93477C27.2251 10.9136 29.1182 12.5173 30.4495 14.5512C31.7808 16.5851 32.4931 18.9617 32.5 21.3926ZM22.5 6.39258V23.8926H17.5V6.39258H22.5ZM7.5 21.3926C7.50686 18.9617 8.21918 16.5851 9.55051 14.5512C10.8818 12.5173 12.7749 10.9136 15 9.93477V23.8926H7.5V21.3926ZM35 30.1426H5V26.3926H35V30.1426Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsHardHat'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
